export const Settings = {
  insured_value_multiplier: 1.1
}
